import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import AcceptInvite from "./pages/AcceptInvite";
import Dashboard from "./pages/Dashboard";
import Fleet from "./pages/Fleet";
import Maintenance from "./pages/Maintenance";
import Inventory from "./pages/Inventory";
import Manage from "./pages/Manage";
import ChangePassword from "./pages/ChangePassword";
import UnitDetail from "./pages/UnitDetail";
import Shell from "./components/Shell";
import { Loader2 } from "lucide-react";

function Protected({ children, admin = false }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-zinc-950"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Shell>{children}</Shell>;
}

function ChangePasswordGate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-zinc-950"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <ChangePassword />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route path="/change-password" element={<ChangePasswordGate />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/fleet" element={<Protected><Fleet /></Protected>} />
      <Route path="/fleet/:unitId" element={<Protected><UnitDetail /></Protected>} />
      <Route path="/maintenance" element={<Protected><Maintenance /></Protected>} />
      <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
      <Route path="/manage" element={<Protected admin><Manage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
